import Locale from "lib/interfaces/locale";

import { fetchJsonSync } from "lib/utilities/network";
import { assetURL } from "lib/utilities/asset";

export default class Lang {
	id:string = "";
	strings:Map<string, string> = new Map<string, string>();
	locale:Locale;
	onFinish:Function;
	
	/**
		* Constructor for class
		
		* @param id		-	Language id. e.g. `en_GB`
	*/
	constructor(id:string) {
		this.loadData(id);
	}
	
	/**
		* Loads language data synchronously and stores values in `this.strings` map.
	*/
	public loadData(locale:string) {
		const newLocale:boolean = locale != this.id;
		const entries = fetchJsonSync(assetURL(`assets/localization/${locale}.json`));
		
		if(!entries) 
			return this.onFinish?.(false);
		
		Object.entries(entries).forEach(([key, value]) => {
			this.strings.set(String(key), String(value));
		});
		
		this.onFinish?.(true);
		this.onFinish = null;
		
		_config.languageId = locale;
		this.id = locale;
		
		_events.invoke("new-lang", newLocale);
		
		console.log(`Loaded localization data for ${this.id}`);
	}
	
	/**
		* Get short language id
		* @returns {string} languageId - Short language id e.g. 'en'
	*/
	public getShortId():string {
		return this.id.split("-")[0];
	}
	
	/**
		* Get country id
		* @returns {string} countryId - Short country id e.g. 'GB'
	*/
	public getCountryId():string {
		return this.id.split("-")[1];
	}
	
	/**
		* Set language id
		@param {string} languageId - e.g. en-GB
	*/
	public setLanguageId(locale:string, onFinish:Function = null) {
		this.onFinish = onFinish;
		this.loadData(locale);
	}
	
	/**
		* Load override source
		* @param {string} url source
	*/
	public loadOverrideSource(source:string) {
		const entries = fetchJsonSync(source);
		
		if(entries)
			this.applyOverride(entries);
	}
	
	/**
		* Apply override to strings
		* @param {any} object
	*/
	public applyOverride(entries:any) {
		Object.entries(entries).forEach(([key, value]) => {
			this.strings.set(String(key), String(value));
		});
	}
}